/* istanbul ignore file */
export { default } from './FlexiLeaseFormInfoLegend';
